import { createTheme } from '@mui/material/styles';

const theme = createTheme({
  palette: {
    primary: {
      light: '#d3c3f6',
      main: '#5F2EE2',
      dark: '#251bcd',
      contrastText: '#fff',
    },
    secondary: {
      light: '#e6bcf4',
      main: '#b82ee2',
      dark: '#6900cb',
      contrastText: '#000',
    },
  },
});

export default theme;
